import React from 'react';

import {
  FormControl,
  FormControlLabel,
  Box,
  FormHelperText,
  Switch,
} from '@mui/material';

export default function NonRegionalOutputDisabledField({
  value,
  setValue,
  setChanged,
}) {
  return (
    <Box>
      <FormControl fullWidth>
        <FormControlLabel
          control={
            <Switch
              checked={value}
              onChange={() => {
                setChanged();
                setValue(!value);
              }}
            />
          }
          label='Disable Non-Regional Outputs'
        />
        <FormHelperText id='non-regional-output-disable-helper-text'>
          Disable EverywhereFS export destinations and job output types that are
          not backed by regional datastores.
        </FormHelperText>
      </FormControl>
    </Box>
  );
}
